<div class="logout-container auth-shell">
  <div class="container vertical-center">
    <div class="auth-column">
      <img id="nice-img" class="auth-logo" src="assets/images/nice-logo-black-with-white.svg" [alt]="'login.logo' | translate"/>
      <div class="auth-card">
            <div id="status-completed">
              <svg id="status-completed-img" class="status-icon status-icon--success" xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" aria-hidden="true" focusable="false">
                <path d="M32,0A32,32,0,1,0,64,32,32.094,32.094,0,0,0,32,0Zm0,57.6A25.6,25.6,0,1,1,57.6,32,25.675,25.675,0,0,1,32,57.6Z" fill="currentColor"/>
                <path d="M40.8,11.2a3.093,3.093,0,0,0-4.48,0l-16,16-7.04-6.72A3.168,3.168,0,0,0,8.8,24.96l8.96,8.96a3.634,3.634,0,0,0,2.56.96,2.905,2.905,0,0,0,2.24-.96L40.8,15.68a3.093,3.093,0,0,0,0-4.48Z" transform="translate(7.84 10.24)" fill="currentColor"/>
              </svg>
            </div>
            <div id="logout-message">
              <p id="logout-message-p">{{"logout.message" | translate}}</p>
            </div>
            <button type="button" id="btnGoLoginPage" class="auth-primary-button" (click)="goLoginPage()">{{"logout.btn.goLoginPage" | translate}}</button>
      </div>
    </div>
  </div>
  <footer class="copyRight-contactUs" id="copyRight-contactUs">
    <span id="copyrightMessage">{{copyrightMessage}}</span>
  </footer>
</div>
